import InlineRecord from './inline-record';

export default InlineRecord;
